<template>
  <v-container class="p-pay-result app-bg">
    <v-layout justify-center>
      <c-icon class="result-img" name="iconchenggong"></c-icon>
    </v-layout>
    <v-layout justify-center align-center column class="mt-4">
      <h2 v-if="isRouter === 'reduce'">减员成功</h2>
      <h2 v-else-if="isRouter === 'add'">增员成功</h2>
      <h2 v-else>投保成功</h2>
      <p class="explain mt-3">保险公司承保后，将会发送电子保单到联系人的邮箱，请注意查收。</p>
      <v-btn to="/" large color="primary mt-4">返回首页</v-btn>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  computed: {
    isRouter(){
      return this.$route.params.url
    }
  }
};
</script>

<style lang="scss" scoped>
.p-pay-result {
  padding: 80px;
  .result-img {
    width: 90px;
    height: 90px;
    color: map-get($theme, success);
  }
  .explain{
    color: #666666;
  }
}
</style>
